import { signal } from '@preact/signals-react';
import type { IQuickServiceItem } from 'QuickBooking/signal';
import { ANYONE_ID } from 'Calendar/anyone';
import { IDatePickerValue } from 'components/DatePicker';
import moment from 'utils/moment';

// Booking-order state owned by ONE caller composer instance. Deliberately not the
// shared Quick Booking signals: the Quick Booking modal (and Book By Staff) reset
// and rewrite those while the caller panel stays open, which silently swapped the
// customer of a caller booking. Nothing outside the composer can write these.
export const createCallerBookingState = () => ({
  staffId: signal<string>(ANYONE_ID),
  requestStaff: signal<boolean>(false),
  date: signal<IDatePickerValue>(moment()),
  startTime: signal<string>(''),
  duration: signal<number>(60),
  note: signal<string>(''),
  services: signal<IQuickServiceItem[]>([]),
});

export type ICallerBookingState = ReturnType<typeof createCallerBookingState>;
